export default __webpack_public_path__ + "static/media/background.e2479c2a.jpg";